import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { NavbarBrand } from "react-bootstrap";

import { HOME } from "../../../constants/messages";
import useMyDpdTheme from "../../Theme/useMyDpdTheme";
import "./styles.scss";

const noop = () => null;

const Brand = ({ href, className, onClick }) => {
  const theme = useMyDpdTheme();
  return (
    <NavbarBrand
      href={href}
      title={HOME}
      className={classNames("mydpd-navbar-brand", className)}
      onClick={onClick}
    >
      <img src={theme.logoImg} width="76" height="32" alt="Site Logo" />
    </NavbarBrand>
  );
};

Brand.defaultProps = {
  onClick: noop,
};

Brand.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  ...NavbarBrand.propTypes,
};

export default Brand;
